import { render, staticRenderFns } from "./Characteristic.vue?vue&type=template&id=2807673a"
import script from "./Characteristic.vue?vue&type=script&lang=js"
export * from "./Characteristic.vue?vue&type=script&lang=js"
import style0 from "./Characteristic.vue?vue&type=style&index=0&id=2807673a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports